import React from 'react';
import { Icon } from './Icon.js';
export const IconCryptoTrendDown = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 13.5L8 19L14 13L21.5 20.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M11 6L7.5 10H6.5L3 6L6.5 2H7.5L11 6Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconCryptoTrendDown.js.map